import React from "react";
import ReactDOM from "react-dom";

import axios, { AxiosResponse } from "axios";
import { Provider } from "react-redux";

import App from "./App";
import { setAdCredentials } from "./services/authentication";
import store from "./store";

import "./index.scss";
import "./services/api";
import "./services/translation/i18n";

axios.get("/api/environment").then((result: AxiosResponse) => {
	setAdCredentials(result.data.tenantId, result.data.clientId);
	ReactDOM.render(
		<Provider store={store}>
			<App loginLogo={result.data.loginLogo} portalLogo={result.data.portalLogo} />
		</Provider>,
		document.getElementById("root")
	);
	document.title = result.data.title;
});
